import { connect } from 'react-redux';
import { requestToggleTheaterView } from '../../../DeviationPage/redux/actions';
import { getIsTheaterForced } from '../../../DeviationPage/redux/selectors';
const mapStateToProps = (state, { deviation })=>({
        isTheaterForced: getIsTheaterForced(state, deviation)
    });
const mapDispatchToProps = {
    onClick: requestToggleTheaterView
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=TheaterButton.container.js.map